import { Link } from 'react-router'
import { ROUTES } from '@/shared/config'

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100dvh-8rem)] gap-6 text-center px-4">
      <h1 className="text-8xl font-bold text-primary">404</h1>
      <h2 className="text-2xl font-semibold">Page Not Found</h2>
      <p className="text-muted-foreground max-w-md">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to={ROUTES.HOME}
        className="px-6 py-2 rounded-md bg-primary text-primary-foreground hover:opacity-90 transition-opacity"
      >
        Go Home
      </Link>
    </div>
  )
}